import { createApp } from 'vue'
import { createPinia } from 'pinia'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import 'element-plus/theme-chalk/dark/css-vars.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'

import App from './App.vue'
import router, { installGuards } from './router'
import './styles/index.css'
import CommonComponents from './components/common'
import Directives from './directives'

const app = createApp(App)

// 注册 Element Plus 图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

// 注册通用组件
app.use(CommonComponents)
app.use(Directives)

const pinia = createPinia()
app.use(pinia)
app.use(router)

// 现在 Pinia 已激活，再安装路由守卫（内部会 useAdminStore）
installGuards()

app.use(ElementPlus, {
  locale: zhCn,
  size: 'default',
  zIndex: 3000,
})

app.mount('#app') 